import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'

import { MappedAffiliatedCompany } from './MappedAffiliatedCompany'

export const columns = (
  onEdit: (item: MappedAffiliatedCompany) => void,
  onDelete: (item: MappedAffiliatedCompany) => void
): TableColumn<MappedAffiliatedCompany>[] => [
  {
    align: 'center',
    title: 'Name',
    render: ({ affiliatedCompanyId, affiliatedCompanyName }) => (
      <Link to="/relationships/$id" params={{ id: affiliatedCompanyId.toString() }}>
        {affiliatedCompanyName}
      </Link>
    )
  },
  {
    align: 'center',
    title: 'Notes',
    key: 'notes'
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'edit',
            onClick: () => onEdit(item)
          },
          {
            type: 'delete',
            onClick: () => onDelete(item)
          }
        ]}
        dataQaAttribute={`Affiliated companies-menu-dots-button-${item.id}`}
      />
    )
  }
]
